import React from 'react';
import iconX from '@static/images/icon_x.svg';
import { Button } from '../../Button/index.ts';
import { Image } from '../../Image/index.ts';
import styles from './DialogCancelButton.module.scss';
/** Cancel button for a dialog. Defaults to an X icon; pass children to override. */ export function DialogCancelButton({ onClick, disabled = false, children }) {
    return /*#__PURE__*/ React.createElement(Button, {
        variant: "secondary",
        size: 'md',
        disabled: disabled,
        onClick: onClick,
        fullWidth: true
    }, children !== null && children !== void 0 ? children : /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: iconX,
            alt: 'strings:colonistCommon.buttons.cancel'
        }
    }));
}
